export default __webpack_public_path__ + "static/media/clients.0c9b212e.svg";